module.exports = __webpack_public_path__ + "img/umanawelfare-logo-no-bg.8d48edf9.png";